import { hasCapability, type CapabilityKey } from "@/app/lib/capabilities"

/**
 * Component-side capability check for nav items and conditional UI.
 * Capabilities are fixed for the lifetime of the page (meta-tag delivered);
 * a mid-session toggle surfaces as a capability-403 from the API, which the
 * api client answers with a full reload.
 */
export function useCapability(key: CapabilityKey): boolean {
  return hasCapability(key)
}
